



































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import addNewAddress from './addNewAddress.vue';
import { addressList, delAddress, defaultAddress, getNextAddress } from '@/utils/api';
import { addressForm } from '../interface';
import tableEmpty from '@/components/empty/tableEmpty.vue'
@Component({ components: { addNewAddress,tableEmpty } })
export default class returnTheGoods extends Vue {
  $bus: any;
  dialog: boolean = false;
  title: string = '添加地址';
  // 收集请求列表数据
  addressForm: addressForm = {
    addressType: 'REFUND_GOODS_ADDRESS',
    // 地址类型：REFUND_GOODS_ADDRESS，退货地址；DELIVER_GOODS_ADDRESS，发货地址
    cityId: null,
    // 市Id
    districtId: null,
    // 区Id
    iphone: null,
    // 联系人手机号
    ownerCode: null,
    // 所属人
    page: 0,
    // 页码
    postCode: null,
    // 邮政编码
    provinceId: null,
    // 省Id
    size: 20,
    // 条数
    streetId: null,
    // 街道Id
    telephone: null,
    userName: null
    // 联系人
  };
  // table 数据展示
  tableData3: Array<Object> = [];
  // 收集编辑提交数据
  addressEdit: object = {};
  loading: boolean = false;
  mounted() {
    this.getAddressList(this.addressForm);
    this.$bus.$on('searchForm', val => {
      this.getAddressList(val);
    });
  }
  // 获取地址列表
  getAddressList(addressForm) {
    this.loading = true;
    addressList(addressForm)
      .then(res => {
        if (res) {
          this.tableData3 = res.content;
          this.loading = false;
        }
      })
      .catch(err => {
        console.log(err);
        this.$message.error(err);
        this.loading = false;
      });
  }
  // 删除
  onConfirm(row) {
    delAddress(row.id)
      .then(res => {
        if (res) {
          this.$message.success(res);
          this.getAddressList(this.addressForm);
        }
      })
      .catch(err => {
        console.log(err);
        this.$message.error(err);
      });
  }
  // 接收emit 关闭drawer
  showMsg(data) {
    if (!data) {
      this.getAddressList(this.addressForm);
    }
  }
  // 添加/编辑
  handleClick(title, row) {
    this.title = title;
    console.log(this.title);
    if (this.title == '编辑地址') {
      this.addressEdit = JSON.parse(JSON.stringify(row));
    } else if (this.title == '添加地址') {
      this.addressEdit = {};
    }
    this.dialog = true;
  }
  // 关闭drawer回调
  handleClose1(done) {
    this.$confirm('确认关闭？')
      .then(_ => {
        this.getAddressList(this.addressForm);

        done();
      })
      .catch(_ => {});
    // console.log((this as any).$refs.drawer.$children[0].$children[0].resetFields());
  }
  // 设为默认地址
  defaultAddress(row) {
    defaultAddress(row.id)
      .then(res => {
        if (res) {
          this.$message.success(res);
          this.getAddressList(this.addressForm);
        }
      })
      .catch(err => {
        console.log(err);
        this.$message.error(err);
      });
  }
}
